const messagesInSpanish = {
  financialServices: "Servicios financieros",
};

export { messagesInSpanish };
